export default __webpack_public_path__ + "static/media/visa-logo.dc673801.svg";